import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IDatasourceUpdate} from '@/api/types/datasource';
import {EDatasourceType} from '@/api/enums/datasource';

import {datasourceAPI} from '@/api/requesters/datasource';

import {datasourceClickhouseController} from '@/services/controllers/datasource/credentials/clickhouse';

const fieldNames: TAPIElementFieldNames<IDatasourceUpdate> = {
  pageTitle: 'Источники данных',
  drawerTitle: 'Источник данных',

  name: 'Название',
  type: 'Тип',
  credentials: 'Данные для доступа',
};

const useDatasourceControllerHook = () => {
  const api = datasourceAPI.clone();

  const validate = (form?: IDatasourceUpdate) => {
    return (
      !!form?.name &&
      !!form.type &&
      !!form.credentials &&
      (form.type === EDatasourceType.CLICKHOUSE
        ? datasourceClickhouseController.validate(form.credentials)
        : true)
    );
  };

  return {
    ...api,
    fieldNames,
    fieldNamesCredentials: {
      [EDatasourceType.CLICKHOUSE]: datasourceClickhouseController.fieldNames,
    },

    validate,
  };
};

export const datasourceController = useDatasourceControllerHook();
